import React, { useState, forwardRef } from "react";
import PropTypes from "prop-types";

/**
 *  <PasswordMask
 *    id="password"
 *    name="password"
 *    value={password}
 *    onChange={handlePasswordChange}
 *    showButtonContent={<SampleEyeShow />}
 *    hideButtonContent={<SampleEyeHide />}
 *    buttonClassName="button--toggle"
 *    className="button-toggle-wrap"
 *  />
 */

const PasswordMask = forwardRef(
  (
    {
      value,
      onChange,
      showButtonContent,
      hideButtonContent,
      buttonClassName = "",
      className = "",
      ...inputProps
    },
    ref
  ) => {
    const [visible, setVisible] = useState(false);

    return (
      <div className={`password-mask ${className}`}>
        <input
          {...inputProps}
          ref={ref}
          type={visible ? "text" : "password"}
          value={value}
          onChange={onChange}
        />

        <button
          type="button"
          aria-label={visible ? "Ukryj hasło" : "Pokaż hasło"}
          onClick={() => setVisible((v) => !v)}
          className={`password-mask__toggle ${buttonClassName}`}
        >
          {visible ? hideButtonContent : showButtonContent}
        </button>
      </div>
    );
  }
);

PasswordMask.displayName = "PasswordMask";

PasswordMask.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  showButtonContent: PropTypes.node.isRequired,
  hideButtonContent: PropTypes.node.isRequired,
  buttonClassName: PropTypes.string,
  className: PropTypes.string,
};

export default PasswordMask;
